import React, { useEffect, useRef, useState } from 'react'
import './SignUpScreen.css'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { analytics, auth, db, functions } from '../../firebase.js'
import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { neo4jcreateUserNode } from '../../services/neo4j';
import { httpsCallable } from 'firebase/functions';
import { checkIfUsernameExists, getUserInfoWithId, getUserInfoWithUsername } from '../../services/f';
import { Oval } from 'react-loader-spinner'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';

function SignUpScreen() {
    const navigate = useNavigate();
    const [email, setemail] = useState("");
    const [username, setusername] = useState("");
    const [pw, setpw] = useState("");
    const [acceptedtos, setacceptedtos] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [usernametaken, setusernametaken] = useState(false);
    const [errorsignup, seterrorsignup] = useState(false);
    const [signuperrormsg, setsignuperrormsg] = useState("");
    const [sthempty, setsthempty] = useState(false);
    const [errorlogin, seterrorlogin] = useState(false);

    const [referralname, setreferralname] = useState(null);
    const [referralid, setreferralid] = useState(null);

    const [logintype, setlogintype] = useState(true);

    const [novalidemail, setnovalidemail] = useState();

    const [showanimation, setshowanimation] = useState(false);

    const [signedupfornewsletter, setsignedupfornewsletter] = useState(false);
    const [newslettererror, setnewslettererror] = useState(false);

    useEffect(() => {
        console.log("referralname", referralname)
        if (referralname === null || referralname === undefined) {

        } else {
            getUserInfoWithUsername(referralname).then((referraldoc) => (setreferralid(referraldoc)))
        }
    }, [referralname]);

    useEffect(() => {
        // homelink so /
        let referral = searchParams.get("referral")
        if (referral === null || referral === undefined) {

        } else {
            setreferralname(referral)
        }

        //console.log("referralid", referral)
    }, []);

    const mapSignupError = (error) => {
        const code = error?.code || "";
        switch (code) {
            case "auth/email-already-in-use":
                return "This email is already registered. Try signing in instead.";
            case "auth/invalid-email":
                return "That email address is invalid.";
            case "auth/weak-password":
                return "Password must be at least 6 characters.";
            case "auth/operation-not-allowed":
                return "Email/password sign-up is disabled in Firebase Auth.";
            case "auth/too-many-requests":
                return "Too many attempts. Please try again later.";
            case "auth/network-request-failed":
                return "Network error. Check your connection and try again.";
            default:
                return error?.message
                    ? `Sign up failed (${code || "unknown"}): ${error.message}`
                    : "There was an error signing up. Check valid e-mail.";
        }
    };

    const register = (e) => {
        e.preventDefault();
        console.log("[signup] 1 start register click");
        setshowanimation(true);
        seterrorlogin(false);
        seterrorsignup(false);
        setsignuperrormsg("");
        setusernametaken(false);

        const cleanEmail = email.trim();
        const cleanUsername = username.trim();
        const cleanPw = pw;
        console.log("[signup] 2 cleaned inputs", {
            email: cleanEmail,
            username: cleanUsername,
            pwLength: cleanPw.length,
            referralname,
            referralid,
        });

        if (cleanEmail === "" || cleanUsername === "" || cleanPw === "") {
            console.warn("[signup] abort: empty fields");
            setsthempty(true);
            setshowanimation(false);
            return;
        }
        setsthempty(false);

        if (cleanPw.length < 6) {
            console.warn("[signup] abort: weak password length", cleanPw.length);
            seterrorsignup(true);
            setsignuperrormsg("Password must be at least 6 characters.");
            setshowanimation(false);
            return;
        }

        console.log("[signup] 3 checkIfUsernameExists…");
        checkIfUsernameExists(cleanUsername.toLowerCase()).then((res) => {
            console.log("[signup] 4 username check result", res);
            if (res.length !== 0) {
                console.warn("[signup] abort: username taken");
                setusernametaken(true);
                setshowanimation(false);
                return;
            }

            console.log("[signup] 5 createUserWithEmailAndPassword…");
            createUserWithEmailAndPassword(auth, cleanEmail, cleanPw)
                .then((userCredential) => {
                    const user = userCredential.user;
                    console.log("[signup] 6 Firebase Auth user created", {
                        uid: user.uid,
                        email: user.email,
                        authCurrentUser: auth.currentUser?.uid,
                    });
                    const createWholeUser = httpsCallable(functions, 'createWholeUser');
                    const payload = {
                        user: user.uid,
                        username: cleanUsername.toLowerCase(),
                        email: cleanEmail,
                        referralid: referralid === null ? null : referralid[0],
                        referralname: referralname,
                    };
                    console.log("[signup] 7 createWholeUser call", payload);
                    createWholeUser(payload)
                        .then((result) => {
                            console.log("[signup] 8 createWholeUser response", result?.data, result);
                            if (result.data === "success") {
                                console.log("[signup] 9 neo4jcreateUserNode…");
                                neo4jcreateUserNode(cleanUsername)
                                    .then((neoResult) => {
                                        console.log("[signup] 10 neo4jcreateUserNode result", neoResult);
                                        if (neoResult !== "success") {
                                            console.error("[signup] neo4jcreateUserNode returned non-success", neoResult);
                                        }
                                        const createSubcollectionForUser = httpsCallable(functions, 'createSubcollectionForUser');
                                        console.log("[signup] 11 createSubcollectionForUser…", user.uid);
                                        createSubcollectionForUser({ user: user.uid })
                                            .then((result) => {
                                                console.log("[signup] 12 createSubcollectionForUser response", result?.data, result);
                                                if (result.data === "success") {
                                                    console.log("[signup] 13 SUCCESS — navigating to feed /alternativehomepage");
                                                    setshowanimation(false);
                                                    logEvent(analytics, "signedup");
                                                    navigate("/alternativehomepage");
                                                } else {
                                                    console.error("[signup] createSubcollectionForUser non-success", result?.data);
                                                    seterrorsignup(true);
                                                    setsignuperrormsg("Account created, but profile setup failed. Please retry or contact support.");
                                                    setshowanimation(false);
                                                }
                                            })
                                            .catch((error) => {
                                                console.error("[signup] createSubcollectionForUser failed", error?.code, error?.message, error);
                                                seterrorsignup(true);
                                                setsignuperrormsg("Account created, but profile setup failed. Please retry or contact support.");
                                                setshowanimation(false);
                                            });
                                    })
                                    .catch((error) => {
                                        console.error("[signup] neo4jcreateUserNode failed", error?.code, error?.message, error);
                                        seterrorsignup(true);
                                        setsignuperrormsg("Account created, but profile graph setup failed. Please retry or contact support.");
                                        setshowanimation(false);
                                    });
                            } else {
                                console.error("[signup] createWholeUser non-success", result?.data);
                                seterrorsignup(true);
                                setsignuperrormsg("Account created, but profile setup failed. Please retry or contact support.");
                                setshowanimation(false);
                            }
                        })
                        .catch((error) => {
                            console.error("[signup] createWholeUser failed", error?.code, error?.message, error);
                            seterrorsignup(true);
                            setsignuperrormsg("Account created, but profile setup failed. Please retry or contact support.");
                            setshowanimation(false);
                        });
                })
                .catch((error) => {
                    console.error("[signup] Firebase Auth signUp failed", error?.code, error?.message, error);
                    seterrorsignup(true);
                    setsignuperrormsg(mapSignupError(error));
                    setshowanimation(false);
                });
        }).catch((error) => {
            console.error("[signup] checkIfUsernameExists failed", error?.code, error?.message, error);
            seterrorsignup(true);
            setsignuperrormsg("Could not verify username. Please retry.");
            setshowanimation(false);
        });
    }

    const signIn = (e) => {
        seterrorsignup(false)
        setshowanimation(true)
        // console.log("sign in now")
        e.preventDefault();

        if (email === "" || pw === "") {
            setsthempty(true)
            setshowanimation(false)
            return
        } else {
            setsthempty(false)
        }

        signInWithEmailAndPassword(
            auth,
            email,
            pw,
        ).then((authuser) => {
            setshowanimation(false)
            logEvent(analytics, "signedin")
            navigate("/alternativehomepage")
        }).catch((error) => {
            seterrorlogin(true)
            setshowanimation(false)
        })
    }

    const isValidEmail = (emailtotext) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(emailtotext);
    };

    const getNotified = (e) => {
        seterrorsignup(false)
        setshowanimation(true)
        // console.log("sign in now")
        e.preventDefault();

        console.log("getnotifed function", email)

        if (email === "") {
            setsthempty(true)
            setshowanimation(false)
            return
        } else {
            console.log("first", isValidEmail(email))
            if (isValidEmail(email) === false) {
                setnovalidemail(true)
                setshowanimation(false)

            } else {
                setnovalidemail(false)
                setsthempty(false)
                //continue to send email to sendgrid
                console.log("sending email to backend<")
                const sendemailfromnewslettertosendgrid = httpsCallable(functions, 'sendemailfromnewslettertosendgrid');
                sendemailfromnewslettertosendgrid({ email: email })
                    .then((result) => {
                        console.log("sendemailfromnewslettertosendgrid", result)
                        if (result.data === "success") {
                            //console.log("worked buying")
                            setshowanimation(false)
                            setsignedupfornewsletter(true)
                            //refresh user account or financials
                        } else {
                            //if response is error let user know with alert or so
                            setshowanimation(false)
                            setnewslettererror(true)
                        }
                    })
                    .catch((error) => {
                        setshowanimation(false)
                        setnewslettererror(true)
                    });
            }
        }

    }

    return (
        <div className="SignupScreen">
            <form>
                {/*
                {!logintype ?
                    <>
                        <h1 style={{ textAlign: "left" }}>Sign In</h1>
                        <p style={{ color: "white", marginBottom: 20 }}>Premsi is still invite-only to exclusive and supportive users. You can sign-up and become an early user over our App</p>

                        <input onChange={(e) => setemail(e.target.value)} type="email" placeholder='Email address' />
                        <input onChange={(e) => setpw(e.target.value)} type="password" placeholder='Password' />
                        {showanimation ?
                            <Oval
                                height={40}
                                width={40}
                                color="#009FFD"
                                wrapperStyle={{ flex: "display", alignItems: "center", justifyContent: "center" }}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="white"
                                strokeWidth={5}
                                strokeWidthSecondary={5}
                            />
                            :
                            <button style={{ borderRadius: 50 }} onClick={signIn} type="submit" >Sign In</button>}
                    </>
                    :
                    <>
                        <h1 style={{ textAlign: "center" }}>Invite <span className="font-body-inline">-</span> Only</h1>

                        <p style={{ color: "white", marginBottom: 10 }}>Premsi is still invite-only to exclusive and supportive users. Put in your invite code in our App!</p>

                        <p style={{ color: "white", marginBottom: 10 }}>Don't have one? Just follow and DM us on IG and X and we will give it to you, or invite 3 friends.</p>

                        <p style={{ color: "white", marginBottom: 20 }}>Or put in your email below to get notified when we let in more users.</p>

                        <input onChange={(e) => setemail(e.target.value)} type="email" placeholder='Email address' />
                        {showanimation ?
                            <Oval
                                height={40}
                                width={40}
                                color="#009FFD"
                                wrapperStyle={{ flex: "display", alignItems: "center", justifyContent: "center" }}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="white"
                                strokeWidth={5}
                                strokeWidthSecondary={5}
                            />
                            :
                            <div class="hero-cta">
                                {false && <button style={{ borderRadius: 50 }} onClick={getNotified} type="submit" >Get notified</button>}

                                <button onClick={() => getNotified()} type="submit" class="btn-hero btn-get-started">Get notified</button>
                            </div>

                        }
                        {sthempty ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>Fill out your email.</p> : null}
                        {novalidemail ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>Your email has an issue.</p> : null}
                        {signedupfornewsletter && <p style={{ textAlign: "center", color: "green", fontSize: 12 }}>You're signed up. We will let you in soon.</p>}
                        {newslettererror && <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>There is an issue somewhere.</p>}
                    </>
                }
                
                <h5 style={{ textAlign: "center" }}>
                    <span style={{ color: "gray", marginRight: 5, textAlign: "center" }}>{logintype === false ? "New to Premsi?" : "Already have an account?"}</span>
                    <span className="SignupScreen__link" onClick={() => (setpw(""), setusername(""), setemail(""), setlogintype(!logintype))}>{logintype === false ? "Sign Up" : "Sign in"}</span>
                </h5>
                */}

                {/* uncomment below when start premsi for real */}
                
                {!logintype ?
                    <>
                        <h1 style={{ textAlign: "left" }}>Sign In</h1>
                        <input onChange={(e) => setemail(e.target.value)} type="email" placeholder='Email address' />
                        <input onChange={(e) => setpw(e.target.value)} type="password" placeholder='Password' />
                        {showanimation ?
                            <Oval
                                height={40}
                                width={40}
                                color="#009FFD"
                                wrapperStyle={{ flex: "display", alignItems: "center", justifyContent: "center" }}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="white"
                                strokeWidth={5}
                                strokeWidthSecondary={5}
                            />
                            :
                            <button style={{borderRadius:50}} onClick={signIn} type="submit" >Sign In</button>}
                    </>
                    :
                    <>
                        <h1 style={{ textAlign: "left" }}>Sign Up</h1>
                        <input onChange={(e) => setusername(e.target.value)} type="text" placeholder='Username' />
                        <input onChange={(e) => setemail(e.target.value)} type="email" placeholder='Email address' />
                        <input onChange={(e) => setpw(e.target.value)} type="password" placeholder='Password' />
                        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "start" }}>
                            <input onChange={() => setacceptedtos(!acceptedtos)} type="checkbox" id="scales" name="scales" checked={acceptedtos} />
                            <label for="scales" style={{ marginLeft: 5, fontSize: 13 }}>Accept <a href="termsofservice" style={{ color: "white" }}>Terms of Service</a></label>
                        </div>
                        {showanimation
                            ?
                            <Oval
                                height={40}
                                width={40}
                                color="#009FFD"
                                wrapperStyle={{ flex: "display", alignItems: "center", justifyContent: "center" }}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="white"
                                strokeWidth={5}
                                strokeWidthSecondary={5}
                            />
                            :
                            (acceptedtos ? <button  style={{borderRadius:50}} onClick={register} type="submit" >Create Account</button> : <div className="accepttosbutton" >Please accept TOS</div>)}
                        {searchParams.get("referral") === null
                            ?
                            null
                            :
                            (referralid === "empty"
                                ?
                                <h6 style={{ color: "gray" }}>Referral doesn't exist!</h6>
                                :
                                <h6 style={{ color: "gray" }}>Your referral: {referralname}</h6>)
                        }
                    </>
                }
                {usernametaken ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>Username taken! Choose another</p> : null}
                {errorsignup ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>{signuperrormsg || "There was an error signing up. Check valid e-mail."}</p> : null}
                {sthempty ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>Fill out everything.</p> : null}
                {errorlogin ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>There was an error loging in. Check password/email.</p> : null}

                <h5>
                    <span style={{ color: "gray", marginRight: 5 }}>{logintype === false ? "New to Premsi?" : "Already have an account?"}</span>
                    <span className="SignupScreen__link" onClick={() => (setpw(""), setusername(""), setemail(""), setlogintype(!logintype))}>{logintype === false ? "Sign Up now." : "Sign in"}</span>
                </h5>
                
            </form>
        </div>
    )
}

export default SignUpScreen
